// Import styles first
import '../css/app.css';

// Import dependencies
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ToastProvider } from './components/ui/toast';
import { initializeTheme } from './hooks/use-appearance';

declare global {
    function route(name: string, params?: any): string;
}

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

// Initialize app
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.tsx`, import.meta.glob('./Pages/**/*.tsx')),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <ToastProvider>
                <App {...props} />
            </ToastProvider>
        );
    },
    progress: {
        color: '#0d9488',
    },
}).catch(error => {
    console.error('Inertia initialization error:', error);
    document.body.innerHTML = `
        <div style="color: red; padding: 20px;">
            <h1>Error</h1>
            <pre>${error.message}</pre>
        </div>
    `;
});

// This will set light / dark mode on load...
initializeTheme();

// Import bootstrap after app initialization
import './bootstrap';
